import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';

@Component({
  selector: 'app-pdup',
  templateUrl: './pdup.component.html',
  styleUrls: ['./pdup.component.css']
})
export class PdupComponent implements OnInit {


  bdnuForm: any;
  submitted:any;

  public state:any;
  public district:any;
  cities: any = {};

  countries = [
    {
      id: 1,
      cities: ['iticode 11', 'iticode 12', 'iticode 13'],
    },
    {
      id: 2,
      cities: ['iticode 21', 'iticode 22', 'iticode 23'],
    },
    {
      id: 3,
      cities: ['iticode 31', 'iticode 32', 'iticode 33'],
    },
  ];
  trades: any = ['trade 11', 'trade 12', 'trade 13'];
  singlerollnoval: any = ['11111', '222222', '33333'];

  public date = new Date().getDate();
  public month = new Date().getMonth() + 1;
  public year = new Date().getFullYear();
  public currentDate = this.date + '-' + this.month + '-' + this.year;

  datePickerConfig = {
    format: 'DD-MM-YYYY',
    max: this.currentDate,
  };

  public readioSelected: any;
  showcontent_cls: boolean = false;
  showbtn_value: any;
  public bulk_bool = false;
  public single_bool = false;
  public numberStud:any;
  totAmount: any;


  constructor(private formBuilder: FormBuilder, private api: ApiService) { }

  ngOnInit(): void {
    this.cities = this.countries.filter((x) => x.id == 1)[0].cities;
  }

  get f() {
    return this.bdnuForm.controls;
  }

  onSubmit() {

    this.submitted = true;

    // stop here if form is invalid
    if (this.bdnuForm.invalid) {
      return;
    }

    alert("SUCESS");
    console.log(this.bdnuForm.value);
    this.api
      .insertbdnuForm(this.bdnuForm.value)
      .subscribe((result: any) => {
        console.log("bdnu: " + result);
      });
  }

  onChangeState(data:any){
    //console.log(data.target.value);
    var myargs = {
      stateName: data.target.value
    }
    this.api.enterState(myargs).subscribe((result:any)=>{
      //console.log(JSON.stringify(result));
      this.district = result;
    });
  }

  showContent(event: any) {
    //this.formArr.removeAt(0);
    this.showbtn_value = event;
    if (event == 'radio1') {
      this.bulk_bool = true;
      this.single_bool = false;
      // this.registerForm.controls["singlerollno"].clearValidators();

      this.bdnuForm.get('singlerollno').clearValidators();
      this.bdnuForm.get('singlerollno').value = '';
      this.bdnuForm.get('singlerollno').updateValueAndValidity();
      this.bdnuForm.get('numberofstud').setValidators([Validators.required]);
      this.bdnuForm.get('amount').setValidators([Validators.required]);
      //this.registerForm.get('singlerollno').clearValidators();
    } else {
      this.bulk_bool = false;
      this.single_bool = true;
      this.bdnuForm.get('numberofstud').clearValidators();
      this.bdnuForm.get('numberofstud').value = '';
      this.bdnuForm.get('numberofstud').updateValueAndValidity();
      this.bdnuForm.get('amount').clearValidators();
      this.bdnuForm.get('amount').value = '';
      this.bdnuForm.get('amount').updateValueAndValidity();
      this.bdnuForm
        .get('singlerollno')
        .setValidators([Validators.required]);
    }

    this.showcontent_cls = this.readioSelected;
  }


  onKey(event:any){
    console.log(event.target.value);
    this.totAmount = event.target.value * 376;
  }

  onReset() {
    this.submitted = false;
    this.bdnuForm.reset();
  }





}
